/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Nexy_Feature_2_TitleInputs */

const es_home_nexy_feature_2_title = /** @type {(inputs: Home_Nexy_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Síntesis Multi-fuente`)
};

const en_home_nexy_feature_2_title = /** @type {(inputs: Home_Nexy_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-source Synthesis`)
};

/**
* | output |
* | --- |
* | "Multi-source Synthesis" |
*
* @param {Home_Nexy_Feature_2_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_nexy_feature_2_title = /** @type {((inputs?: Home_Nexy_Feature_2_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Nexy_Feature_2_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_nexy_feature_2_title(inputs)
	return en_home_nexy_feature_2_title(inputs)
});
export { home_nexy_feature_2_title as "home.nexy.feature_2_title" }